import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChildren, signal } from '@angular/core';

import { AuxTabComponent } from '@shared/components/tab-group/aux-tab.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgTemplateOutlet],
  selector: 'aux-tab-group',
  template: `
    <div class="mt-8 border-b border-gray-200">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        @for (tab of tabChildren(); track $index) {
          <button
            type="button"
            class="whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium focus:outline-none"
            [ngClass]="{
              'border-aux-blue-light text-aux-blue-light': $index === activeTabIndex(),
              'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                $index !== activeTabIndex(),
            }"
            [attr.data-pendo-id]="tab.pendoTag"
            (click)="activeTabIndex.set($index)"
          >
            {{ tab.label() }}
          </button>
        }
      </nav>
    </div>

    @for (tab of tabChildren(); track $index) {
      @if ($index === activeTabIndex()) {
        <ng-container *ngTemplateOutlet="tab.tmp()" />
      }
    }
  `,
})
export class TabGroupComponent {
  activeTabIndex = signal(0);

  tabChildren = contentChildren(AuxTabComponent);

  setActiveTabIndex(tabIndex: number): void {
    this.activeTabIndex.set(tabIndex);
  }
}
